/* eslint-disable */
export enum FinnairItineraryNote {
  REQUIRES_AIRPORT_CHANGE = 'REQUIRES_AIRPORT_CHANGE',
  HAS_NEXT_DAY_TRANSFER = 'HAS_NEXT_DAY_TRANSFER',
  HAS_LONG_TRANSFER = 'HAS_LONG_TRANSFER'
}

